import { render, staticRenderFns } from "./ProfileIdentVolunteerFormCommon.vue?vue&type=template&id=6cad2036"
import script from "./ProfileIdentVolunteerFormCommon.vue?vue&type=script&lang=ts"
export * from "./ProfileIdentVolunteerFormCommon.vue?vue&type=script&lang=ts"
import style0 from "./ProfileIdentVolunteerFormCommon.vue?vue&type=style&index=0&id=6cad2036&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports